import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";
import _ from "lodash";
import {Item, Table} from "semantic-ui-react";
import {Gebaeude} from "../../../../models/gebaeude";
import SVG from "react-inlinesvg";
import rightArrow from "../../../../assets/images/layout/right-arrow.svg";

export interface GebaeudeTableProps {
    data: Gebaeude[];
    handleShowGebaeude: (egid: number, event: React.MouseEvent) => void;
    title?: string;
}
interface SortAction {
    type: string;
    column: string;
}
@observer
export class GebaeudeTable extends Component<GebaeudeTableProps, any> {
    watchHandles: any[] = [];
    constructor(props: GebaeudeTableProps) {
        super(props);
        this.state = {
            column: "nummer",
            data: _.orderBy(this.props.data, ["nummer"], ["asc"]),
            direction: "ascending"
        };
        this.sort = this.sort.bind(this);
    }
    sort(action: SortAction): void {
        switch (action.type) {
        case "CHANGE_SORT":
            if (this.state.column === action.column) {
                this.setState({
                    ...this.state,
                    data: this.state.data.reverse(),
                    direction:
                            this.state.direction === "ascending" ? "descending" : "ascending"
                });
            } else {
                this.setState({
                    column: action.column,
                    data: _.sortBy(this.state.data, [action.column]),
                    direction: "ascending",
                });
            }
            return;
        default:
            throw new Error();
        }
    }
    showGebaeude(egid: number, event: React.MouseEvent): void {
        this.props.handleShowGebaeude(egid, event);
    }
    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
    }
    render(): React.ReactElement | null {
        const { column, data, direction } = this.state;
        if (data === null){
            return null;
        }
        let title: string;
        if (this.props.title) {
            title = this.props.title;
        } else {
            title = "Gebäude auf diesem Grundstück";
        }
        if (data.length === 0) {
            return (
                <Item><Item.Content><Item.Header as="h3">{title}</Item.Header>
                    <p>keine</p>
                </Item.Content></Item>);
        }
        return (
            <Item><Item.Content><Item.Header as="h3">{title}</Item.Header>
                <Table basic="very" sortable={(data.length > 1)} compact className={"gebaeude"}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell singleLine
                                sorted={column === "nummer" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "nummer" })}>
                            Nr.</Table.HeaderCell>
                            <Table.HeaderCell singleLine
                                sorted={column === "egid" ? direction : null}
                                className={"number"}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "egid" })}>
                            EGID</Table.HeaderCell>
                            <Table.HeaderCell singleLine
                                sorted={column === "bezeichnung" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "bezeichnung" })}>
                            Bezeichnung</Table.HeaderCell>
                            <Table.HeaderCell singleLine
                                colSpan={2}
                                sorted={column === "status" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "status" })}>
                            Status</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {data.map((gebaeude: Gebaeude) => (
                            <Table.Row key={gebaeude.egid} onClick={(event: React.MouseEvent) =>
                                this.showGebaeude(gebaeude.egid, event)}>
                                <Table.Cell>{gebaeude.nummer}</Table.Cell>
                                <Table.Cell>{gebaeude.egid}</Table.Cell>
                                <Table.Cell>{gebaeude.bezeichnung}</Table.Cell>
                                <Table.Cell singleLine className={"status"}>{gebaeude.status}</Table.Cell>
                                <Table.Cell>
                                    <span className={"sprite sprite--right-arrow"}><SVG src={rightArrow} /></span>
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body></Table>
            </Item.Content></Item>
        );
    }
}
